import { render, staticRenderFns } from "./DateCategory.vue?vue&type=template&id=0b145acb&scoped=true"
import script from "./DateCategory.vue?vue&type=script&lang=js"
export * from "./DateCategory.vue?vue&type=script&lang=js"
import style0 from "./DateCategory.vue?vue&type=style&index=0&id=0b145acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b145acb",
  null
  
)

export default component.exports